<template>
    <div class="cuerpo_row">
        <div class="cuerpo-column1">
            <nav
                class="navbar navbar-expand-xl navbar-dark bg-dark menutab-submenu"
                id="nav"
            >
                <h2 class="navbar-brand page-title"><!-- {{ dataView.nom }} --></h2>
                <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    id="navbarsExample06x"
                    data-target="#navbarsExample06"
                    aria-controls="navbarsExample06"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    @click="showAsideMet()"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarsExample06">
                    <ul class="navbar-nav mr-auto">
                        <!-- <li class="nav-item" v-if="groups.length < 2">
                            <a class="nav-link active">
                                {{ groupSelect }}
                            </a>
                        </li> -->
                        <!-- <li class="nav-item" v-else> -->
                        <li class="nav-item">
                            <a class="nav-link active" @click="changeGroup()" style="cursor:pointer">
                                {{ groupSelect }}
                                <i class="fas fa-chevron-down" style="font-size: 12px; margin-left: 5px" ></i>
                            </a>
                        </li>                        
                        <!-- <li class="nav-item" v-else>
                            <dropdown-menu
                                v-model="showGroup"
                                :right="right"
                                :hover="hover"
                            >
                                <button class="btnDrop">
                                    <span class="nomGroupSelected"
                                        >{{ groupSelect }}
                                    </span>
                                    <i
                                        class="fas fa-chevron-down"
                                        style="font-size: 12px; margin-left: 5px"
                                    ></i>
                                </button>
                                <div slot="dropdown">
                                    <div
                                        class="dropdown-item"
                                        v-for="(i, index) in groups"
                                        :key="index"
                                        @click="changeGroup(i, index)"
                                        style="width: 250px"
                                    >
                                        <a
                                            v-bind:class="[
                                                i.visible === 1 ? 'activeGroup' : '',
                                                'text-left',
                                            ]"
                                            style="color: inherit !important"
                                        >
                                            {{ i.name }}
                                            <b
                                                class="badge badge-success"
                                                v-if="i.visible === 1"
                                                style="
                                                    margin: 5px;
                                                    font-size: 9px;
                                                    float: right;
                                                "
                                            >
                                                {{ $t("lang.label_selected") }}
                                            </b>
                                        </a>
                                    </div>
                                </div>
                            </dropdown-menu>
                        </li> -->
                    </ul>
                    <ul class="navbar-nav menu-rigth">
                        <li class="nav-item">
                            <button
                                type="button"
                                class="btn btn-add-group"
                                @click="addCat"
                            >
                                {{ $t("lang.label_add_ctgory") }}
                            </button>
                        </li>
                    </ul>
                </div>
            </nav>
            <loader v-if="isloading"></loader>
            <div v-else>
                <menucat
                    :categoryItems="get_listCategores"              
                ></menucat>
            </div>
        </div>
        <div :class="['cuerpo-column2', showAside === true ? 'show' : '']">
            <div class="sidebar-header">{{ $t("lang.label_ctgory") }}</div>
            <div class="sidebar-content"></div>
            <menuaside></menuaside>
            <!-- <extras></extras> -->
        </div>

        <!-- modal -->
        <modalLateral>
            <component v-bind:is="m.component"></component>
        </modalLateral>        
    </div>
</template>

<script>
import Loader from "@/components/shared/Loader";
import menucat from "@/components/dimenu/menu/menu_cat";
// import extras from '@/components/dimenu/menu/extras'
import menuaside from "@/components/dimenu/menu/menu_aside";
import EventBus from "@/eventBus";
// import DropdownMenu from "@innologica/vue-dropdown-menu";
import modalLateral from "@/components/themeModalLateral/modalLateral"
import ActionMenuChange from "@/components/dimenu/menu/ActionMenuChange"
import variantForm from "@/components/dimenu/menu/variantForm"
import { mapGetters } from "vuex";
export default {
    name: "menu_editor",
    components: {
        Loader,
        // extras,
        menucat,
        menuaside,
        // DropdownMenu,
        modalLateral,
        ActionMenuChange,
        variantForm,
    },
    props: {
        subitems: { type: Object, required: true },
    },
    data () {
        return {
            m: {
                show: false,
                component: "",
                data: [],
            },
            isloading: false,
            category: [],
            groups: [],
            viewAside: false,
            itemCategory: {},
            boxAside: "",
            showAside: false,
            groupSelect: window.lang2.label_ungrouped,
            showGroup: false,
            right: false,
            hover: false,
            /* category: [
				{
					id: 0,
					view: 2,
					name: 'category1',
					descrip: 'category description',
					portada: '',
					verPlatos: false,
					status: true,
					platos: [{
						id: 0,
						view: 2,
						name: 'Plato 1',
						descrip: 'Description',
						precio: 0,
						img: '',
						status: true,
						edit: false,
						isSize: false,
						size: [{
								id: 0,
								name: 'Normal',
								precio: 0,
								required: true,
							}]
					}],
				}],  */
        }
    },
    mounted () {
        this.getGroup();
    },
    created () {
        //console.log('menu_submenu ',this.subitems);
    },
    methods: {
        changeGroup(i, index) {
            let t = this
            this.m = {
                show: true,
                component: "ActionMenuChange",
                action: "ActionMenuChange",
                data: {
                    dat: t.groups,
                    actionForm: "ActionMenuChange",
                },
            };
            this.$store.commit("setOpenModal", this.m);
        },
        showAsideMet() {
            this.showAside = !this.showAside;
        },
        getGroup() {
            this.isloading = true;
            window.master
                .get("getgroup/" + window.master_client + "/" + window.localuserdata)
                .then((response) => {
                    // console.log('group list base', response.data.result);
                    if (response.data.result && response.data.result.length > 0) {
                        let e = response.data.result;
                        // console.log(e);
                        for (let i in e) {
                            this.groups.push({
                                id: e[i].id,
                                name: e[i].name,
                                active: e[i].active,
                                visible: 0,
                                primary_group:e[i].primary_group
                            });
                        }
                        this.groups[0].visible = 1;
                        this.groupSelect = this.groups[0].name;
                        this.$store.commit("SET_GROUPACTIVE", this.groups[0].id);
                        this.$store.commit("SET_GROUPLIST", this.groups);
                        this.getCategories(this.groups[0]); // carga por primera vez
                    } else {
                        // console.log('group vacio');
                        this.isloading = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isloading = false;
                });
        },
        getCategories(i) {
            this.isloading = true;
            this.$store
                .dispatch("getCategories", i)
                .then((response) => {
                    // console.log('category list base', response)
                    this.init(response);
                    this.isloading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isloading = false;
                });
        },
        init(response) {
            let d = response;
            let u = Array();
            let count = 0;
            for (const i in d) {
                let platos = d[i].platos;
                let entries = Object.entries(platos);
                let plato = [];
                // convert to array platos
                for (let i in entries) {
                    let element = entries[i];
                    for (let y in element) {
                        if (typeof element[y] !== "string") {
                            let rl = element[y];
                            if (typeof rl === "object") {
                                plato.push(rl);
                            }
                        }
                    }
                }
                if (platos.length > 0) {
                    count = count + 1;
                    if (count === 1) {
                        u.push({
                            opts: d[i].opts,
                            description: d[i].description,
                            error_image: d[i].error_image,
                            group_id: d[i].group_id,
                            id: d[i].id,
                            image: d[i].image,
                            is_file: d[i].is_file,
                            name: d[i].name,
                            org_id: d[i].org_id,
                            // platos: d[i].platos,
                            platos: plato,
                            sizes: d[i].sizes,
                            small: d[i].small,
                            status: d[i].status,
                            url: d[i].url,
                            user_id: d[i].user_id,
                            verPlatos: true,
                            view: d[i].view,
                            type: d[i].type,
                        });
                    } else {
                        u.push({
                            opts: d[i].opts,
                            description: d[i].description,
                            error_image: d[i].error_image,
                            group_id: d[i].group_id,
                            id: d[i].id,
                            image: d[i].image,
                            is_file: d[i].is_file,
                            name: d[i].name,
                            org_id: d[i].org_id,
                            // platos: d[i].platos,
                            platos: plato,
                            sizes: d[i].sizes,
                            small: d[i].small,
                            status: d[i].status,
                            url: d[i].url,
                            user_id: d[i].user_id,
                            verPlatos: false,
                            view: d[i].view,
                            type: d[i].type,
                        });
                    }
                } else {
                    u.push({
                        opts: d[i].opts,
                        description: d[i].description,
                        error_image: d[i].error_image,
                        group_id: d[i].group_id,
                        id: d[i].id,
                        image: d[i].image,
                        is_file: d[i].is_file,
                        name: d[i].name,
                        org_id: d[i].org_id,
                        // platos: d[i].platos,
                        platos: plato,
                        sizes: d[i].sizes,
                        small: d[i].small,
                        status: d[i].status,
                        url: d[i].url,
                        user_id: d[i].user_id,
                        verPlatos: false,
                        view: d[i].view,
                        type: d[i].type,
                    });
                }
                count++;
            }
            this.$store.commit("SET_LISTCATEGORES", []);
            this.$store.commit("SET_LISTCATEGORES", u);
        },
        addCat() {
            EventBus.$emit("newCategory");
            this.action = "create";
            //let idNew = (parseInt(this.category.length) + 1);
            let check = this.get_listCategores.filter((item) => item.id === 0);
            if (check.length < 1) {
                this.get_listCategores.push({
                    opts: null,
                    id: 0,
                    view: 1,
                    name: "",
                    image: "",
                    price: 0,
                    description: "",
                    portada: "",
                    error_image: false,
                    verPlatos: false,
                    status: true,
                    is_file: false,
                    platos: [],
                    sizes: [],
                    type: "category",
                    agruparOpt: [],
                });
            }
        },
        activateEditAdi() {
            let t = this;
            let y = [];
            this.m = {
                show: true,
                component: "variantForm",
                data: {
                    dat: this.getOpenModal.data.dat,
                },
            };
            this.$store.commit("setOpenModal", this.m);
        },        
    },
    watch: {
        get_listCategores: function () {
            // console.log('get_listCategores')
            this.category = this.get_listCategores;
        },
        getOpenModal: function () {
            let r = this.getOpenModal.data
            if (this.getOpenModal.show === false) {                
                if (r.actions === "ReturnActionMenuChange") {
                    this.groupSelect = r.groupSelect
                    this.getCategories(r.i);
                }
                if (r.actions === "ReturnActionMenuDel") {
                    // this.groups = []
                    // this.getGroup();
                    let v = r.visible.length
                    if (v > 0) {                        
                        let b = r.visible                        
                        let id = b[0].id
                        let name = b[0].name
                        let primary_group = b[0].primary_group
                        let gs = this.groups
                        for (let i in gs) {
                            if (gs[i].id === id) {
                                if (gs[i].visible === 1) {
                                    this.groups[i].visible = 1
                                    this.groups[i].name = name
                                    this.groupSelect = name
                                } else {
                                    this.groups[i].name = name
                                }
                            } else {
                                this.groups[i] = gs[i]
                            }
                        }
                    }                    
                } 
                if (r.actions === "ReturnActionMoveFood") {                    
                    this.groups = []
                    this.groups = r.group
                }                                
            } 
            if (this.getOpenModal.shown == true) {
                this.activateEditAdi()
            }
        },        
    },
    computed: {
        ...mapGetters(["get_listCategores", "getOpenModal"]),
    },
}
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
    #navbarsExample06x {
        display: none;
    }
    .navbar-expand-xl .navbar-collapse {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -ms-flex-preferred-size: auto;
        flex-basis: auto;
    }
}
.cuerpo_row {
    min-height: calc(100vh - 5.5rem);
    width: 100%;
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
    overflow: hidden;
}
.cuerpo-column1 {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: hidden;
}
.cuerpo-column2 {
    display: flex;
    flex-direction: column;
    flex: 0 0 320px;
    overflow: hidden;
    z-index: 20;
    background: #fff;
    border-left: 1px solid #d5d5d3;
    box-shadow: 0 1px 3px rgba(0, 1, 1, 0.25);
    transition: all 0.3s ease-in-out;
    @media (max-width: 767px) {
        right: -100%;
        position: absolute;
        top: 44px;
        width: 100%;
        height: 100vh;
        &.show {
            right: 0%;
            transition: all 0.3s ease-in-out;
            -webkit-transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            -o-transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            -webkit-box-shadow: 0 0 13px 0 rgba(21, 21, 21, 0.16);
            box-shadow: 0 0 13px 0 rgba(21, 21, 21, 0.16);
        }
    }
}
@keyframes swingParent {
    from {
        transform: translateX(0);
        left: 0;
    }
    to {
        left: 100%;
        transform: translateX(-100%);
    }
}
.sidebar-header {
    font-weight: 700;
    font-size: 17px;
    color: #727272;
    display: flex;
    background: #eee;
    padding: 0.4rem 1rem;
}
.sidebar-content {
    overflow: auto;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}
.menutab-submenu {
    background-color: #585858 !important;
    padding: 0rem 1rem;
    padding-left: 0px;
}
h2.navbar-brand.page-title {
    min-width: 0px;
    padding-bottom: 3px;
    padding-right: 0px;
    margin: 0;
}
.navbar-expand-xl .navbar-nav > li:nth-child(1) {
}

.navbar-expand-xl .navbar-nav > li.nav-item {
    padding: 0px;
}
.navbar-expand-xl .navbar-nav > li.nav-item > a {
    padding: 0.5rem 1rem;
    text-transform: uppercase;
}
.navbar-expand-xl .navbar-nav > li.nav-item > a.active,
.navbar-expand-xl .navbar-nav > li.nav-item > a:hover {
    background-color: #585858;
    color: #fff !important;
    font-weight: bold;
}
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
.btn-add-group:hover {
    color: #212529;
    background-color: #e0e0e0;
    border-color: #b3b2b2;
}

.boxAside {
    position: absolute;
    height: calc(100vh - 10vw);
    overflow: hidden;
    overflow-y: scroll;
    width: 100%;
    padding-right: 15px;
    padding-bottom: 20px;
}
.boxAside::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    width: 10px;
    background-color: #f5f5f5;
}
.boxAside::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
}
.boxAside::-webkit-scrollbar-thumb {
    background-color: #222223;
}
.contentBox {
    input {
        border: 1px solid #b1b1b1;
    }
    button {
        width: 100%;
    }
}
.cuerpo-column2 {
    display: flex;
    flex-direction: column;
    flex: 0 0 320px;
    overflow: hidden;
    z-index: 20;
    background: #fff;
    border-left: 1px solid #d5d5d3;
    box-shadow: 0 1px 3px rgba(0, 1, 1, 0.25);
}
.sidebar-header {
    font-weight: 700;
    font-size: 17px;
    color: #727272;
    display: flex;
    background: #eee;
    padding: 0.4rem 1rem;
}
.sidebar-content {
    overflow: auto;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}
.sidebar-footer {
    flex: 1000 1 auto;
    margin: 15px;
    position: relative;
    margin-right: 0;
}
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
.btn-add-group:hover {
    color: #212529;
    background-color: #e0e0e0;
    border-color: #b3b2b2;
}
.btn-aside {
    max-width: 200px;
    margin: 0 auto;
    display: block;
}
/*SWICHT*/
.btn-switch {
    display: inline-block;
    float: right;
}
.onoffswitch {
    position: relative;
    width: 60px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #585858;
    border-radius: 20px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.1s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 20px;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "Encendido";
    padding-right: 10px;
    background-color: #585858;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Apagado";
    padding-right: 10px;
    background-color: #d65353;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    display: block;
    width: 15px;
    height: 15px;
    margin: 6px;
    background: #fff;
    position: absolute;
    top: -3px;
    bottom: 0;
    right: 33px;
    border: 1px solid #585858;
    border-radius: 20px;
    transition: all 0.1s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
.mascara {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 0;
    top: -1px;
    left: 0;
    z-index: 1;
}
a.activeGroup.text-left {
    font-weight: 600;
}
span.nomGroupSelected {
    font-weight: bold;
    text-transform: uppercase;
}
button.btnDrop:focus {
    outline: none;
}
</style>
